import type { ImplProps, ImplResponse } from './api-request';

export async function apiFetchRequest({
  body,
  fullDomain,
  headers,
  method,
  signal,
}: ImplProps): Promise<ImplResponse> {
  const isFormData = body instanceof FormData;

  const requestHeaders: Record<string, string> = {};
  if (!isFormData) {
    requestHeaders['Content-Type'] = 'application/json';
  }
  if (headers) {
    for (const key in headers) {
      requestHeaders[key] = String(headers[key]);
    }
  }

  let requestBody: BodyInit | undefined;
  if (body !== undefined && method.toUpperCase() !== 'GET') {
    requestBody =
      isFormData || typeof body === 'string'
        ? (body as BodyInit)
        : JSON.stringify(body);
  }

  let response: Response;
  try {
    response = await fetch(fullDomain, {
      method: method.toUpperCase(),
      credentials: 'include',
      headers: requestHeaders,
      body: requestBody,
      signal,
    });
  } catch (e) {
    throw new Error(e instanceof Error ? e.message : String(e), { cause: e });
  }

  const responseText = await response.text();
  const contentType = response.headers.get('content-type') ?? '';
  const isJson = contentType.includes('application/json');

  let parsedBody: unknown;
  if (responseText.length > 0 && isJson) {
    try {
      parsedBody = JSON.parse(responseText);
    } catch {
      parsedBody = responseText;
    }
  }

  return {
    ok: response.ok,
    status: response.status,
    body: parsedBody,
    text: responseText,
    response,
  };
}
